import { getOwnProfilePath, normalizeProfileUrl } from "./profilePaths";
import { toSameOriginPath } from "./safeAppUrl";

const COMMENT_SECTION_TYPES = new Set([
  "post_comment",
  "comment_reply",
  "post_follow",
]);

const withCommentScroll = (destination, notification) => {
  const pathname = destination?.pathname || "";
  const postPath = pathname.split(/[?#]/)[0];
  if (!COMMENT_SECTION_TYPES.has(notification?.type) || !postPath.startsWith("/post/")) {
    return destination;
  }

  return {
    ...destination,
    pathname: postPath,
    hash: "#comments-section",
    state: {
      ...destination.state,
      scrollToComments: true,
    },
  };
};

export const resolveNotificationNavigation = (
  notification,
  user,
  { notificationsPath, messagesPath } = {},
) => {
  const id = notification?._id || notification?.id;
  const type = notification?.type || "";
  const url = toSameOriginPath(notification?.url || notification?.actionUrl || "") || "";
  const resolvedNotificationsPath =
    notificationsPath || getOwnProfilePath(user, "/notifications");
  const resolvedMessagesPath =
    messagesPath || getOwnProfilePath(user, "/messages");

  if (type === "marketplace_message") {
    return {
      pathname: "/marketplace/messages",
      state: {
        startConversationWith: notification?.data?.senderId
          ? { _id: notification.data.senderId }
          : undefined,
        listingId: notification?.data?.listingId || null,
        notificationId: id,
      },
    };
  }

  if (type === "message" && notification?.data?.senderId) {
    return {
      pathname: normalizeProfileUrl(url || resolvedMessagesPath, user),
      state: {
        startConversationWith: { _id: notification.data.senderId },
        notificationId: id,
      },
    };
  }

  if (type === "moderation" && url.startsWith("/marketplace/")) {
    return { pathname: url, state: { notificationId: id } };
  }

  const normalizedUrl = url ? normalizeProfileUrl(url, user) : "";

  if (
    type === "moderation" ||
    !url ||
    normalizedUrl === resolvedNotificationsPath
  ) {
    return {
      pathname: resolvedNotificationsPath,
      state: { notificationId: id, openNotification: notification },
    };
  }

  return withCommentScroll(
    {
      pathname: normalizedUrl,
      state: { notificationId: id },
    },
    notification,
  );
};

export const isNotificationClickable = (notification) => {
  const type = notification?.type || "";
  const url = toSameOriginPath(notification?.url || notification?.actionUrl || "") || "";

  if (type === "marketplace_message" || type === "message" || type === "moderation") {
    return true;
  }

  return Boolean(url);
};
